import { z } from "zod";
import { PayStandPaymentTokenSchema } from "./pay-stand-payment-token";

export const PayStandCheckoutDataSchema = z.object({
  type: z.string(),
  flow: z.string(),
  object: z.string(),
  data: PayStandPaymentTokenSchema,
});

export type PayStandCheckoutDataType = z.infer<
  typeof PayStandCheckoutDataSchema
>;
